const INITIAL_STATE = {
    url: null,
    open: false,
    visualized: false,
    openNpsScript: false
  }
  
  export default function npsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
      case 'SET_URL':
        return {
          ...state,
          url: action.url
        }
      case 'SET_OPEN': 
        return {
          ...state,
          open: action.open,
          openNpsScript: action.openNpsScript,
        }
      case 'SET_VISUALIZED': 
        return {
          ...state,
          visualized: action.visualized,
        }
      default:
        return state;
    }
  }
